import { Injectable } from "@angular/core";
import { Observable, catchError } from "rxjs";
import { Address } from "../../models/address.model";
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: "root"
})
export class AddressService {
    validated = {};
    constructor(
        private http: HttpClient
    ) {
        this.validated = {};
    }

    isValidated(address: Address): boolean {
        if (!environment.addressConfirm) {
            return true;
        }

        if (this.validated[this.toKey(address)]) {
            return true;
        }

        return false;
    }

    isEqual(address1: Address, address2: Address): boolean {
        return this.toKey(address1) === this.toKey(address2);
    }

    save(address: Address): void {
        this.validated[this.toKey(address)] = address;
    }

    toKey(address: Address): string {
        const arr = [
            address.addressLine1.toLowerCase().trim(),
            address.addressLine2 ? address.addressLine2.toLowerCase().trim() : "",
            address.city.toLowerCase().trim(),
            address.zipCode.toLowerCase().trim()]

        return arr.join('|');
    }

    format(address: Address): string {
        let ret = address.addressLine1;

        if (address.addressLine2) {
            ret += " " + address.addressLine2;
        }

        if (address.city || address.state) {
            ret += ", ";
        }

        if (!address.city && address.state) {
            ret += address.state;
        } else if (address.city && !address.state) {
            ret += address.city;
        } else {
            ret += address.city + " " + address.state;
        }

        if (address.zipCode) {
            ret += ", " + address.zipCode;
        }

        return ret;
    }
    
    standardize(address : Address): Observable<Address> {
        // @ts-ignore
        const headers: HttpHeaders = new HttpHeaders({
            //'Content-Type': 'multipart/form-data',
            //'enctype': 'multipart/form-data',
            //'Accept': '*/*',
            'x-cea-spatial-subscriber': environment.spatial_subscriber_key
        });

        const postData = {
            AddressLine1: address.addressLine1,
            AddressLine2: address.addressLine2 ? address.addressLine2 : "",
            City: address.city,
            State: address.state,
            ZipCode: address.zipCode,
        };

        //for some reason the endpoint wants the query string data
        const query = "&AddressLine1=" + address.addressLine1 +
            "&AddressLine2=" + (address.addressLine2 ? address.addressLine2 : "") +
            "&City=" + address.city +
            "&State=" + address.state +
        "&ZipCode=" + address.zipCode;

        const options = {
            headers: headers
        };

        return this.http.post<Address>(environment.spatialApi + query, { }, options);
    }

}
